'use client'

import type { ReactNode } from 'react'
import { usePathname } from 'next/navigation'

export function FrontendChrome({
  children,
  footer,
  header,
}: {
  children: ReactNode
  footer: ReactNode
  header: ReactNode
}) {
  const pathname = usePathname()
  const hideChrome = [
    '/t/login',
    '/t/register',
    '/t/forgot-password',
    '/t/reset-password',
  ].includes(pathname)

  return (
    <>
      {hideChrome ? null : header}
      {children}
      {hideChrome ? null : footer}
    </>
  )
}
